<template>
  <div :class="$style.loadingContainer">
    <span :class="[$style.animateFlash, $style.item, $style.item1]"></span>
    <span :class="[$style.animateFlash, $style.item, $style.item2]"></span>
    <span :class="[$style.animateFlash, $style.item, $style.item3]"></span>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
});
</script>

<style lang="scss" module>
.loadingContainer {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-shrink: 0;
}

.animateFlash {
  animation: flash 1.4s linear infinite;
}
.item {
  display: inline-block;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: var(--primary-color, #6360E6);
}

.item2 {
  animation-delay: .2s;
}
.item3 {
  animation-delay: .4s;
}

@keyframes flash {
  0% {
    opacity: .4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: .4;
  }
}
</style>
